import { getSearchApiUrl } from "modules/PsyCatalog/ssg"
import { FetchSearchResponseWithPaging } from "utils/interfaces"
import { CatalogSearchQuery, defaultQuery } from "modules/PsyCatalog/common/searchQuery"
import { httpClient } from "utils/infrastructure/httpClient"

function getRelatedPsysSearchQuery(value: number[]): CatalogSearchQuery {
    return {
        ...defaultQuery,
        competences: value,
    }
}

const MAX_PAGES_COUNT_JUST_GUESS = 30

function random(max: number) {
    return Math.floor(Math.random() * max) + 1
}

async function doRelatedPsysApiCall(pageNumber: number, competences: number[]) {
    return await httpClient.post<FetchSearchResponseWithPaging>(
        getSearchApiUrl(pageNumber),
        Object.assign(getRelatedPsysSearchQuery(competences), {
            profiles_per_page: 10,
            offset_from_utc_minutes: 0,
        })
    )
}
export async function getRelatedPsys(competences: number[]) {
    let randomPage = random(MAX_PAGES_COUNT_JUST_GUESS)
    const data = await doRelatedPsysApiCall(randomPage, competences)

    if (data.profiles.length > 0) return data

    randomPage = random(data.pages_count)

    return doRelatedPsysApiCall(randomPage, competences)
}
